import { useEffect } from "react";

const EMPTY_FAQ = [];

/**
 * Injects FAQPage JSON-LD while mounted (unique scriptAttrValue per page).
 */
export function useFaqPageJsonLd(faq, scriptAttrValue) {
  const list = Array.isArray(faq) ? faq : EMPTY_FAQ;

  useEffect(() => {
    if (!list.length) return;

    const payload = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: list.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.a,
        },
      })),
    };

    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-selena-page", scriptAttrValue);
    el.textContent = JSON.stringify(payload);
    document.head.appendChild(el);

    return () => {
      document.querySelectorAll(`script[data-selena-page="${scriptAttrValue}"]`).forEach((n) => n.remove());
    };
  }, [list, scriptAttrValue]);
}
